import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import vid from '../assets/images/vid-hero2.mp4'
import scndimg from '../assets/images/scnd-screen-img.jpg'
import EmblaCarousel from "../components/EmblaCarousel";
import kfmb from '../assets/images/kfmb.svg';
import kfmb2 from '../assets/images/kfmb2.svg';
import efr from '../assets/images/efr.svg';
import efr2 from '../assets/images/efr2.svg';
import seed from '../assets/images/seed.svg';
import seed2 from '../assets/images/seed2.svg';
import tesla from '../assets/images/tesla.svg';
import tesla2 from '../assets/images/tesla2.svg';
import pandy from '../assets/images/pandy.svg'
import pandy2 from '../assets/images/pandy2.svg'
import lfc from '../assets/images/imgs/lfc2.png'
import lfc2 from '../assets/images/lfc2.svg'
import impact from '../assets/images/imgs/impact.png'
import impact2 from '../assets/images/imgs/impact2.png'
import mapImage from '../assets/images/Map.svg'
import mainpg from '../assets/images/imgen.png'
import mainpgar from '../assets/images/imgar.png'
import { useTranslation } from "react-i18next";
import siximg from '../assets/images/imgs/six-screen-img.jpg'
import i1 from '../assets/images/imgs/i1.png'
import i2 from '../assets/images/imgs/i2.png'
import i3 from '../assets/images/imgs/i3.png'
import i4 from '../assets/images/imgs/i4.png'
import i5 from '../assets/images/imgs/i5.png'
import i6 from '../assets/images/imgs/i6.png'
import i7 from '../assets/images/imgs/i7.png'
import i8 from '../assets/images/imgs/i8.png'
import kfmbbg from '../assets/images/bgimgs/kfmb.jpg';
import pandybg from '../assets/images/bgimgs/pandy.jpg';
import efrbg from '../assets/images/bgimgs/erf.jpg';
import impactbg from '../assets/images/bgimgs/impact.jpg';
import lfcbg from '../assets/images/bgimgs/lfc.jpg';
import teslabg from '../assets/images/bgimgs/tesla.jpg';
import seedbg from '../assets/images/bgimgs/seedawi.jpg';
import malakybg from '../assets/images/bgimgs/malaky.jpg';
import trillo from '../assets/images/trillo.png'
import wrapmaster from '../assets/images/wrapmaster.png'
import c1 from '../assets/images/bgimgs/row-1-column-1.png'
import c2 from '../assets/images/bgimgs/row-2-column-1.png'
import c3 from '../assets/images/bgimgs/row-3-column-1.png'
import c4 from '../assets/images/bgimgs/row-4-column-1.png'
import c5 from '../assets/images/bgimgs/row-5-column-1.png'
import c6 from '../assets/images/bgimgs/row-6-column-1.png'
import trillo2 from '../assets/images/trillo2.png'
import trillo3 from '../assets/images/trillo3.jpg'
import goldenshine from '../assets/images/goldenshine.png'
import goldenshine2 from '../assets/images/goldenshine2.jpg'
import wrapmaster2 from '../assets/images/wrapmaster2.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShop, faCartShopping, faStore, faShoppingBasket, faLaptop, faUtensils } from '@fortawesome/free-solid-svg-icons';

const slides = [
    { v: kfmb, h: kfmb2, t: 'kfmb', bg: kfmbbg },
    { v: efr, h: efr2, t: 'egyptian-rice', bg: efrbg },
    { v: seed, h: seed2, t: 'seedawi', bg: seedbg },
    { v: trillo, h: trillo, t: 'Trillo', bg: trillo3 },
    { v: wrapmaster, h: wrapmaster, t: 'Wrap-Master', bg: wrapmaster2 },
    { v: goldenshine, h: goldenshine, t: 'golden-shine', bg: goldenshine2 },
    // { v: pandy, h: pandy2, t: 'pandy', bg: pandybg },
    // { v: lfc, h: lfc2, t: 'lfc', bg: lfcbg },
    // { v: impact, h: impact2, t: 'impact', bg: impactbg }
]

export default function Home() {
    const { t, i18n } = useTranslation()

    useEffect(() => {
        document.body.classList.add('home')
    }, [])

    return (
        <div id="content">
            <section className="pb-[30px] min-h-fit lg:min-h-screen">
                <video style={{ width: '100vw', height: 'auto' }} onContextMenu={(e) => e.preventDefault()} src={vid} autoPlay muted loop playsInline />
                <div className="flex justify-between items-center gap-[30px] p-[10px] md:p-[20px] md:px-[100px] md:pt-[20px] flex-col xl:flex-row">
                    <span className="w-full xl:w-[600px] 2xl:w-[1100px]">
                        <h3 className="nc text-lg md:text-xl text-start">{t('transforming_fmcg')}</h3>
                    </span>
                    <span className="flex justify-center items-center p-[20px] md:p-[0px]">
                        <Link to='/services' className="text-white underline underline-offset-[5px] nbg p-[8px] rounded-full px-[20px] text-lg hover:bg-[#D0A847] hover:text-[#201B57] transition-all duration-[.3s]">{t('discover_services')}</Link>
                    </span>
                </div>
            </section>

            {/* *************************************************************************** */}

            <section>
                <div className="flex px-[10px] md:px-[20px] lg:px-[50px] xl:px-[100px] py-[20px] lg:py-[30px] xl:py-[50px] gap-[30px] flex-col lg:flex-row">
                    <div className="w-full lg:w-[400px] xl:w-[400px] 2xl:w-[600px]">
                        <img className="block w-full lg:w-[400px] xl:w-[400px] 2xl:w-[600px]" src={scndimg} alt={t('second_image_alt')} />
                    </div>
                    <div className="w-full lg:w-[75%]">
                        <div>
                            <h2 className="is-slideup text-lg lg:text-xl xl:text-2xl 2xl:text-5xl nc font-black w-full lg:w-[600px] 2xl:w-[900px]">
                                {t('operating_since')} <span className="font-thin">{t('operating_since1')}</span> {t('operating_since2')} <span className="font-thin">{t('operating_since3')}</span> {t('operating_since4')}
                            </h2>
                        </div>
                        <div className="flex flex-col gap-[10px] py-[30px] lg:py-[10px]">
                            <div className="flex items-end justify-between border-b border-b-[2px] py-[15px]">
                                <div className="w-[35%]">
                                    <div className="text-2xl lg:text-4xl 2xl:text-6xl nc">190+</div>
                                    <span className="text-lg lg:text-xl 2xl:text-4xl gc">{t('empowered_minds')}</span>
                                </div>
                                <div className="w-[65%]">
                                    <p className="text-md lg:text-lg 2xl:text-2xl nc">
                                        {t('united_values')}
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-end justify-between border-b border-b-[2px] py-[15px]">
                                <div className="w-[35%]">
                                    <div className="text-2xl lg:text-4xl 2xl:text-6xl nc">2</div>
                                    <span className="text-lg lg:text-xl 2xl:text-4xl gc">{t('official_offices')}</span>
                                </div>
                                <div className="w-[65%]">
                                    <p className="text-md lg:text-lg 2xl:text-2xl nc">
                                        {t('ensuring_transparency')}
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-end justify-between border-b border-b-[2px] py-[15px]">
                                <div className="w-[35%]">
                                    <div className="text-2xl lg:text-4xl 2xl:text-6xl nc">7</div>
                                    <span className="text-lg lg:text-xl 2xl:text-4xl gc">{t('warehouses')}</span>
                                </div>
                                <div className="w-[65%]">
                                    <p className="text-md lg:text-lg 2xl:text-2xl nc">
                                        {t('warehouse_space')}
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-end justify-between border-b border-b-[2px] py-[15px]">
                                <div className="w-[35%]">
                                    <div className="text-2xl lg:text-4xl 2xl:text-6xl nc">7000+</div>
                                    <span className="text-lg lg:text-xl 2xl:text-4xl gc">{t('points_of_sale')}</span>
                                </div>
                                <div className="w-[65%]">
                                    <p className="text-md lg:text-lg 2xl:text-2xl nc">
                                        {t('trusting_years')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* *************************************************************************** */}

            <section className="advantages-section p-[10px] lg:p-[50px] py-[50px] md:py-[150px] xl:p-[100px] py-[50px] h-fit md:h-[calc(100vh+50px)]">
                <div className="w-full md:w-lg lg:w-[700px] font-black my-[50px] lg:my-[100px]">
                    <h2 className="is-slideup text-xl md:text-xl lg:text-5xl 2xl:text-6xl nc font-thin">
                        {t('what_makes_trust')} <span className="font-black">{t('what_makes_trust1')}</span> {t('what_makes_trust2')}
                    </h2>
                </div>
                <div className="pl-[50%]">
                    <ol className="flex items-center gap-[30px] relative left-[10%] my-[100px] snap-x snap-mandatory scroll-smooth w-full px[0px]">
                        <li className="advantage snap-start w-screen md:w-[450px] h-[220px] md:h-[260px] shrink-0 border-[.5px] border-[#D0A847] rounded-[20px] p-[30px]">
                            <span className="flex gap-[20px]">
                                <span className="text-xl nc">1</span>
                                <h2 className="text-lg md:text-xl lg:text:2xl 2xl:text-4xl nc font-semibold">{t('experience')}</h2>
                            </span>
                            <span className="text-md md:text-md lg:text-lg xl:text-lg 2xl:text:2xl p-[20px] font-thin nc mt-[10px] block">{t('experience_desc')}</span>
                        </li>
                        <li className="advantage snap-start w-screen md:w-[450px] h-[220px] md:h-[260px] shrink-0 border-[.5px] border-[#D0A847] rounded-[20px] p-[30px]">
                            <span className="flex gap-[20px]">
                                <span className="text-xl nc">2</span>
                                <h2 className="text-lg md:text-xl lg:text:2xl 2xl:text-4xl nc font-semibold">{t('focus_safety')}</h2>
                            </span>
                            <span className="text-md md:text-md lg:text-lg xl:text-lg 2xl:text:2xl p-[20px] font-thin nc mt-[10px] block">{t('safety_desc')}</span>
                        </li>
                        <li className="advantage snap-start w-screen md:w-[450px] h-[220px] md:h-[260px] shrink-0 border-[.5px] border-[#D0A847] rounded-[20px] p-[30px]">
                            <span className="flex gap-[20px]">
                                <span className="text-xl nc">3</span>
                                <h2 className="text-lg md:text-xl lg:text:2xl 2xl:text-4xl nc font-semibold">{t('consistency')}</h2>
                            </span>
                            <span className="text-md md:text-lg lg:text-lg xl:text-lg 2xl:text:2xl p-[20px] font-thin nc mt-[10px] block">{t('consistency_desc')}</span>
                        </li>
                        <li className="advantage snap-start w-screen md:w-[450px] h-[220px] md:h-[260px] shrink-0 border-[.5px] border-[#D0A847] rounded-[20px] p-[30px]">
                            <span className="flex gap-[20px]">
                                <span className="text-xl nc">4</span>
                                <h2 className="text-lg md:text-xl lg:text:2xl 2xl:text-4xl nc font-semibold">{t('retail_dominance')}</h2>
                            </span>
                            <span className="text-md md:text-md lg:text-lg xl:text-lg 2xl:text:2xl p-[20px] font-thin nc mt-[10px] block">{t('retail_desc')}</span>
                        </li>
                    </ol>
                </div>
                <div className="flex items-center justify-center mt-[50px]">
                    <Link to='/about' className="text-white underline underline-offset-[5px] nbg p-[8px] rounded-full px-[20px] text-lg hover:bg-[#D0A847] hover:text-[#201B57] transition-all duration-[.3s]">{t('discover_story')}</Link>
                </div>
            </section>
            <section className="h-fit lg:h-[100vh] py-[100px]">
                <div className="flex justify-center items-center">
                    <h1 className="text-lg text-black xl:text-4xl 2xl:text-6xl w-screen lg:w-[650px] text-center is-slideup font-black nc">{t('trusted_brands')} <span className="font-thin">{t('to_every_generation')}</span></h1>
                </div>
                <div className="p-[50px]">
                    <EmblaCarousel slides={slides} />
                </div>
            </section>

            <section
                className="w-screen min-h-screen bg-no-repeat relative py-16"
                style={{
                    backgroundImage: `url(${mapImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: i18n.language === 'en' ? 'left center' : 'right center',
                    backgroundSize: window.innerWidth > 768 ? '40%' : '100%'
                }}
            >
                <span className="z-[-1] text-[15rem] lg:text-[20rem] xl:text-[30rem] 2xl:text-[40rem] absolute top-[-100px] left-1/2 -translate-x-1/2 text-[#eee] opacity-[.5]">UAE</span>
                <div className="p-[50px] lg:p-[100px] w-full flex justify-center lg:w-[800px]">
                    <h1 className="is-slideup text-xl lg:text-2xl xl:text-4xl 2xl:text-5xl font-black nc leading-[20px]">{t('unmatched_delivery')}</h1>
                </div>
                
                <div className="flex justify-center md:justify-end px-[10px] lg:px-[100px] 2xl:px-[100px] scale-[.5] lg:scale-100">
                    <div className="flex">
                        {/* Left vertical text */}
                        <div className="flex items-center justify-center w-[20px]">
                            <div className="transform -rotate-90 origin-center whitespace-nowrap bg-[#E6E4DE] hover:bg-[#D0A847] py-[10px]" style={{ paddingLeft: i18n.language === 'en' ? '110px' : '140px', paddingRight: i18n.language === 'en' ? '110px' : '140px' }}>
                                <p className="text-2xl font-bold  text-[#201B57]">{t('channels')}</p>
                            </div>
                        </div>

                        {/* Main table */}
                        <div className="flex flex-col">
                            <div className="grid grid-cols-[100px_1fr_120px_120px] gap-[10px] mb-[10px] h-[50px]">
                                {/* Row 1 */}
                                <div className="flex items-center justify-center h-full w-[100px]">
                                    <img src={c1} alt="Modern Trade" className="h-12 ps-[20px]" />
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center px-5 pe-[30px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold">{t('modern_trade')}</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">411</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">100 %</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-[100px_1fr_120px_120px] gap-[10px] mb-[10px] h-[50px]">
                                {/* Row 2 */}
                                <div className="flex items-center justify-center h-full w-[100px]">
                                    <img src={c2} alt="Supermarkets" className="h-12 ps-[20px]" />
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center px-5 pe-[30px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold">{t('supermarkets')}</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">342</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">100 %</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-[100px_1fr_120px_120px] gap-[10px] mb-[10px] h-[50px]">
                                {/* Row 3 */}
                                <div className="flex items-center justify-center h-full w-[100px]">
                                    <img src={c3} alt="Groceries" className="h-12 ps-[20px]" />
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center px-5 pe-[30px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold">{t('groceries')}</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">7,700</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">30 %</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-[100px_1fr_120px_120px] gap-[10px] mb-[10px] h-[50px]">
                                {/* Row 4 */}
                                <div className="flex items-center justify-center h-full w-[100px]">
                                    <img src={c4} alt="Discount Stores" className="h-12 ps-[20px]" />
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center px-5 pe-[30px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold">{t('discount_stores')}</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">154</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">100 %</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-[100px_1fr_120px_120px] gap-[10px] mb-[10px] h-[50px]">
                                {/* Row 5 */}
                                <div className="flex items-center justify-center h-full w-[100px]">
                                    <img src={c5} alt="Ecommerce" className="h-12 ps-[20px]" />
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center px-5 pe-[30px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold">{t('ecommerce')}</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">170</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">9 %</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-[100px_1fr_120px_120px] gap-[10px] h-[50px]">
                                {/* Row 6 */}
                                <div className="flex items-center justify-center h-full w-[100px]">
                                    <img src={c6} alt="Horeca" className="h-12 ps-[20px]" />
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center px-5 pe-[30px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold">{t('horeca')}</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">15,000</p>
                                </div>
                                <div className="bg-[#E6E4DE] hover:bg-[#D0A847] flex items-center justify-center w-[120px] h-full">
                                    <p className="text-[#201B57] text-xl font-bold text-start w-full px-[20px]">5 %</p>
                                </div>
                            </div>
                        </div>

                        {/* Right vertical text */}
                        <div className="flex items-center justify-center w-[20px] ms-[30px]">
                            <div className="transform -rotate-90 origin-center whitespace-nowrap bg-[#E6E4DE] hover:bg-[#D0A847] py-[10px]" style={{ paddingLeft: i18n.language === 'en' ? '110px' : '140px', paddingRight: i18n.language === 'en' ? '110px' : '140px' }}>
                                <p className="text-2xl font-bold text-[#201B57]">{t('coverage')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="w-screen h-full md:h-screen flex items-center justify-center py-[50px] lg:pb-[20px]">
                <div className="flex gap-[20px] justify-between w-full flex-col lg:flex-row px-[20px] lg:px-[50px] xl:px-[100px]">
                    <div className="flex flex-col justify-center gap-[30px] lg:gap-[80px]">

                        <h2 className="is-slideup text-xl lg:text-3xl xl:text-5xl 2xl:text-7xl text-start font-thin nc pe-[50px] max-w-[700px]"> <span className="text-center w-full block">{t('connecting_trade')}</span></h2>
                        <div className="flex flex-col md:flex-row gap-[20px]">
                            <div className="flex flex-col gap-[20px]">
                                <span className="flex gap-[10px]">
                                    <span><img className="w-[50px] h-[55px] lg:w-[50px] lg:h-[55px]" src={i1} alt={t('facility_icon_alt')} /></span>
                                    <span>
                                        <h3 className="text-lg lg:text-xl xl:text-2xl nc">{t('vast_facility')}</h3>
                                        <h4 className="gc text-sm lg:text-md xl:text-lg">{t('warehouse_size')}</h4>
                                    </span>
                                </span>
                                <span className="flex gap-[10px]">
                                    <span><img className="w-[50px] h-[55px] lg:w-[50px] lg:h-[55px]" src={i2} alt={t('facility_icon_alt')} /></span>
                                    <span>
                                        <h3 className="text-lg lg:text-xl xl:text-2xl nc">{t('efficient_handling')}</h3>
                                        <h4 className="gc text-sm lg:text-md xl:text-lg">{t('electrical_stackers')}</h4>
                                    </span>
                                </span>
                                <span className="flex gap-[10px]">
                                    <span><img className="w-[50px] h-[55px] lg:w-[50px] lg:h-[55px]" src={i3} alt={t('facility_icon_alt')} /></span>
                                    <span>
                                        <h3 className="text-lg lg:text-xl xl:text-2xl nc">{t('secure_operation')}</h3>
                                        <h4 className="gc text-sm lg:text-md xl:text-lg">{t('video_surveillance')}</h4>
                                    </span>
                                </span>
                                <span className="flex gap-[10px]">
                                    <span><img className="w-[50px] h-[55px] lg:w-[50px] lg:h-[55px]" src={i4} alt={t('facility_icon_alt')} /></span>
                                    <span>
                                        <h3 className="text-lg lg:text-xl xl:text-2xl nc">{t('efficient_handling')}</h3>
                                        <h4 className="gc text-sm lg:text-md xl:text-lg">{t('electrical_stackers')}</h4>
                                    </span>
                                </span>
                            </div>
                            <div className="flex flex-col gap-[20px]">
                                <span className="flex gap-[10px]">
                                    <span><img className="w-[50px] h-[55px] lg:w-[50px] lg:h-[55px]" src={i5} alt={t('facility_icon_alt')} /></span>
                                    <span>
                                        <h3 className="text-lg lg:text-xl xl:text-2xl nc">{t('climate_control')}</h3>
                                        <h4 className="gc text-sm lg:text-md xl:text-lg">{t('central_ac')}</h4>
                                    </span>
                                </span>
                                <span className="flex gap-[10px]">
                                    <span><img className="w-[50px] h-[55px] lg:w-[50px] lg:h-[55px]" src={i6} alt={t('facility_icon_alt')} /></span>
                                    <span>
                                        <h3 className="text-lg lg:text-xl xl:text-2xl nc">{t('accurate_inventory')}</h3>
                                        <h4 className="gc text-sm lg:text-md xl:text-lg">{t('data_scanners')}</h4>
                                    </span>
                                </span>
                                <span className="flex gap-[10px]">
                                    <span><img className="w-[50px] h-[55px] lg:w-[50px] lg:h-[55px]" src={i7} alt={t('facility_icon_alt')} /></span>
                                    <span>
                                        <h3 className="text-lg lg:text-xl xl:text-2xl nc">{t('seamless_workflow')}</h3>
                                        <h4 className="gc text-sm lg:text-md xl:text-lg">{t('loading_unloading')}</h4>
                                    </span>
                                </span>
                                <span className="flex gap-[10px]">
                                    <span><img className="w-[50px] h-[55px] lg:w-[50px] lg:h-[55px]" src={i8} alt={t('facility_icon_alt')} /></span>
                                    <span>
                                        <h3 className="text-lg lg:text-xl xl:text-2xl nc">{t('automated_fleet')}</h3>
                                        <h4 className="gc text-sm lg:text-md xl:text-lg">{t('fleet_system')}</h4>
                                    </span>
                                </span>
                            </div>
                        </div>

                    </div>
                    <div className="flex flex-col items-center">
                        {/* <h3 className="text-md md:text-lg lg:text-2xl nc py-[20px]">{t('nationwide_logistics')}</h3> */}
                        <img src={siximg} alt={t('warehouse_image_alt')} className="w-full lg:w-[400px] xl:w-[550px]" />
                        {/* <h4 className="text-md md:text-lg nc py-[20px] font-bold">{t('continuous_warehousing')}</h4> */}
                    </div>
                </div>
            </section>

            <section className="w-screen min-h-[calc(100vh-200px)] flex flex-col gap-[50px] lg:gap-[50px] items-center justify-center mt-[20px] md:mt-[200px] lg:mt-[20px]">
                <div className="is-slideup flex flex-col gap-[20px] items-start justify-start w-full px-[10px] md:px-[50px] lg:px-[100px] xl:px-[150px] 2xl:px-[200px]">
                    <h1 className="text-start text-lg lg:text-5xl xl:text-7xl font-black capitalize nc"> <span className="text-lg lg:text-7xl xl:text-9xl">{t('our_principles')}</span></h1>
                    <h1 className="text-start text-lg lg:text-5xl xl:text-7xl font-black capitalize nc">
                        <span className="font-thin">{t('ensuring_trust')}</span> <span className="font-black">{t('ensuring_trust2')}</span> <span className="font-thin">{t('ensuring_trust3')}</span> <span className="font-black">{t('ensuring_trust4')}</span>
                    </h1>
                </div>
                <div className="flex flex-wrap p-[10px] lg:p-[10px] gap-[10px] justify-center">
                    <div className="w-full md:w-1/3 xl:w-1/5 gap-[5px] flex border-[.5px] border-[#D0A847] rounded-[30px] p-[20px] nc">
                        <h2>01</h2>
                        <span className="flex flex-col gap-[10px]">
                            <h2 className="font-black text-lg">{t('building_partnerships')}</h2>
                            <h3>{t('partnerships_desc')}</h3>
                        </span>
                    </div>
                    <div className="w-full md:w-1/3 xl:w-1/5 gap-[5px] flex border-[.5px] border-[#D0A847] rounded-[30px] p-[20px] nc">
                        <h2>02</h2>
                        <span className="flex flex-col gap-[10px]">
                            <h2 className="font-black text-lg">{t('professional_culture')}</h2>
                            <h3>{t('culture_desc')}</h3>
                        </span>
                    </div>
                    <div className="w-full md:w-1/3 xl:w-1/5 gap-[5px] flex border-[.5px] border-[#D0A847] rounded-[30px] p-[20px] nc">
                        <h2>03</h2>
                        <span className="flex flex-col gap-[10px]">
                            <h2 className="font-black text-lg">{t('thinking_ahead')}</h2>
                            <h3>{t('growth_desc')}</h3>
                        </span>
                    </div>
                    <div className="w-full md:w-1/3 xl:w-1/5 gap-[5px] flex border-[.5px] border-[#D0A847] rounded-[30px] p-[20px] nc">
                        <h2>04</h2>
                        <span className="flex flex-col gap-[10px]">
                            <h2 className="font-black text-lg">{t('brand_identity')}</h2>
                            <h3>{t('identity_desc')}</h3>
                        </span>
                    </div>
                </div>
            </section>
            <div className="h-[100px]"></div>
        </div>
    )
}